import { RootState } from "../../store";
import { ConnectionStatus } from "../../types/Connection";

export default function isConnected({ connection }: RootState) {
  return (
    connection.connectionState === ConnectionStatus.SUCCESS &&
    connection.joinState === ConnectionStatus.SUCCESS
  );
}
